import Icon from './Icon';

export default Icon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/cf-component-icon/es/index.js
// module id = 325
// module chunks = 0